import Vue from "vue";

const getters = {
  getIncomingCargos: (state) => {
    let arrayOfCargos = _.toArray(state.incomingCargo);

     return _.orderBy(arrayOfCargos);
  },
  getCargo: (state) => (id) => {
    return state.incomingCargo[id] ? state.incomingCargo[id] : false;
  },

  getCargoDocumentByCargoNumber: (state, getters, rootState, rootGetters) => (cargoNumber) => {
    return Vue.prototype.$FB
        .collection('incoming-cargos')
        .where('companyId', '==', rootGetters['users/getMeBasic'].companyId)
        .where('cargoNumber', '==', cargoNumber);
  },

};

export default getters;